// extracted by mini-css-extract-plugin
module.exports = {"AppWrapper":"App_AppWrapper__D4Vsp","AppMain":"App_AppMain__bW6Xs"};